/* eslint-disable react-hooks/exhaustive-deps */
import {
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import { ArrowDropDown } from "@mui/icons-material";
import React, { FC, useEffect, useState } from "react";
import { Componente, ID_INVERSOR, ID_MICROINVERSOR, ID_MODULO, Inversor, Modulo } from "../../types";
import { CollectionUtil } from "src/framework/commons/CollectionUtil";
import { Formater } from "src/framework/commons/Formater";

export enum direciton {
  MODULOS_POR_INVERSOR = "modulo",
  INVERSORES_POR_MODULO = "inversor",
}

export interface ModuloXInversorProperties {
  list: Componente[];
  modulosInversores: Modulo[] | Inversor[];
  onChange?: Function;
  direction: direciton;
}

interface ModuloXInversorState {
  list: any;
  sorterField: SORTER_FILED
  selectedList?: any;
}

enum SORTER_FILED {
  POTENCIA_ASC = "potencia",
  POTENCIA_DESC = "-potencia",
  MODELO_ASC = "modelo",
  MODELO_DESC = "-modelo",
  CODIGO_ASC = "id",
  CODIGO_DESC = "-id",
}

const sorter = (componentes: Componente[], field: SORTER_FILED): any => {
  const list: any = componentes.map((c) => {

    let potencia = null;

    if (c.categoria_componentes_id === ID_MODULO) {
      potencia = c.atributos?.MODULO_POTENCIA
    }
    if ([ID_INVERSOR, ID_MICROINVERSOR].includes(parseInt(String(c.categoria_componentes_id)))) {
      potencia = c.atributos?.INVERSOR_POTENCIA_MAXIMA_SAIDA
    }


    return { ...c, potencia: potencia }
  }).sort(CollectionUtil.singleSort(field))

  return { list: (list as Componente[]), sorterField: field };
}

const ModuloXInversor: FC<ModuloXInversorProperties> = (
  props: ModuloXInversorProperties
) => {
  const key: string = `${props.direction}_id`;


  const [state, setState] = useState<ModuloXInversorState>({
    list: [],
    selectedList: props.modulosInversores,
    sorterField: SORTER_FILED.POTENCIA_ASC
  });


  useEffect(() => {
    setState({ ...state, ...sorter(props.list, SORTER_FILED.POTENCIA_ASC) })
  }, [props.list])


  const [checkedAll, setCheckedAll] = useState<boolean>(props.modulosInversores.length > 0 && props.modulosInversores.length === props.list.length);

  const handleToggleAll = (event: React.ChangeEvent<{ value: unknown; checked: boolean }>): void => {
    let selecteds: any = [...props.modulosInversores];
    if (event.target.checked) {
      for (let componente of props.list) {
        selecteds.push({ [key]: componente.id });
      }
    } else {
      selecteds = []
    }
    setCheckedAll(event.target.checked);

    if (props.onChange) {
      props.onChange(selecteds);
    }
  }

  const handleToggle = (
    event: React.ChangeEvent<{ value: unknown; checked: boolean }>
  ) => {
    const selecteds: any = [...props.modulosInversores];
    const value = parseInt(event.target.value as string);
    const idx = selecteds.findIndex((item: any) => item[key] === value);

    if (event.target.checked) {
      if (idx < 0) {
        selecteds.push({ [key]: value });
      }
    } else {
      if (idx > -1) {
        selecteds.splice(idx, 1);
      }
    }

    if (props.onChange) {
      props.onChange(selecteds);
    }
    return state.selectedList;
  };


  return (
    <section>
      <div className="row">
        <div className="X12">
          <Paper elevation={0}>
            <TableContainer style={{ maxHeight: "660px" }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        onChange={handleToggleAll}
                        value={checkedAll}
                        checked={checkedAll}
                        indeterminate={props.modulosInversores.length > 0 && props.list.length !== props.modulosInversores.length}
                      />
                    </TableCell>
                    <TableCell width={100} align="right">
                      <TableSortLabel
                        IconComponent={ArrowDropDown}
                        active={[String(SORTER_FILED.POTENCIA_ASC), String(SORTER_FILED.POTENCIA_DESC)].includes(String(state.sorterField))}
                        direction={state?.sorterField && state?.sorterField[0] === "-" ? "desc" : "asc"}
                        onClick={() => {
                          setState({
                            ...state,
                            ...sorter(state.list, state.sorterField === SORTER_FILED.POTENCIA_ASC ? SORTER_FILED.POTENCIA_DESC : SORTER_FILED.POTENCIA_ASC)
                          })
                        }}
                      >
                        Potência
                      </TableSortLabel>
                    </TableCell>

                    <TableCell width={260} >
                      <TableSortLabel
                        IconComponent={ArrowDropDown}
                        active={[String(SORTER_FILED.MODELO_ASC), String(SORTER_FILED.MODELO_DESC)].includes(String(state.sorterField))}
                        direction={state?.sorterField && state?.sorterField[0] === "-" ? "desc" : "asc"}
                        onClick={() => {
                          setState({
                            ...state,
                            ...sorter(state.list, state.sorterField === SORTER_FILED.MODELO_ASC ? SORTER_FILED.MODELO_DESC : SORTER_FILED.MODELO_ASC)
                          })
                        }}
                      >
                        Modelo
                      </TableSortLabel>
                    </TableCell>
                    <TableCell align="right" width={100}>
                      <TableSortLabel
                        IconComponent={ArrowDropDown}
                        active={[String(SORTER_FILED.CODIGO_ASC), String(SORTER_FILED.CODIGO_DESC)].includes(String(state.sorterField))}
                        direction={state?.sorterField && state?.sorterField[0] === "-" ? "desc" : "asc"}
                        onClick={() => {
                          setState({
                            ...state,
                            ...sorter(state.list, state.sorterField === SORTER_FILED.CODIGO_ASC ? SORTER_FILED.CODIGO_DESC : SORTER_FILED.CODIGO_ASC)
                          })
                        }}
                      >
                        Código
                      </TableSortLabel>
                    </TableCell>
                    <TableCell />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {state.list?.map((componente: any, index: number) => {
                    const unidadePotencia = ID_MODULO === componente.categoria_componentes_id ? "Wp" : "W"

                    return (
                      <TableRow key={index}>
                        <TableCell padding="checkbox">
                          <Checkbox
                            edge="end"
                            value={componente.id}
                            onChange={handleToggle}
                            checked={
                              props.modulosInversores.findIndex(
                                (item: any) => item[key] === componente.id
                              ) > -1
                            }
                          />
                        </TableCell>
                        <TableCell align="right">{Formater.toString(componente?.potencia || 0)} {unidadePotencia}</TableCell>
                        <TableCell>{componente.modelo}</TableCell>
                        <TableCell align="right">{componente.id}</TableCell>
                        <TableCell />
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </div>
      </div>
    </section>
  );
};

export { ModuloXInversor };
